export const convertUtcToIst = (utcDate) => {
  // Convert UTC to IST (UTC + 5:30)
  const istDate = new Date(utcDate.getTime() + 5.5 * 60 * 60 * 1000);

  // Format the date to ISO string and slice it to match the format
  const istTime = istDate.toISOString().slice(0, 16);
  return istTime;
};

export const statusHandler = (status) => {
  console.log(status, "statusstatus");

  switch (status) {
    case "pendingLead":
      return "Booked";
    case "Pending":
      return "pending";
    case "activeLead":
      return "toDo";
    case "Booked":
      return "Booked";
    case "Sold":
      return "completed";
    case "Blocked":
      return "onHold";
    case "onHold":
      return "onHold";
    case "inProgress":
      return "inProgress";
    case "Available":
      return "toDo";
    case "pending":
      return "pending";
    case "completed":
      return "completed";
    case "todo":
      return "toDo";
    case "read_only":
      return "readOnlyStatus";
    case "read_write":
      return "readWriteStatus";
    case "manage":
      return "manageStatus";
    default:
      return "dynamicStatus";
  }
};

export const capitalizeFirstLetter = (str) => {
  if (!str) return str; // Return the string as is if it's empty or undefined

  // Capitalize the first letter
  const capitalized = str.charAt(0).toUpperCase() + str.slice(1);

  // Remove the trailing "s" if it exists
  return capitalized.endsWith("s") ? capitalized.slice(0, -1) : capitalized;
};

export function pluralizeLastWord(inputString) {
  // Split the string into words
  const words = inputString.split(" ");

  // Get the last word
  const lastWord = words[words.length - 1];

  // Define the pluralization rules
  let pluralWord;
  if (lastWord.endsWith("y")) {
    pluralWord = lastWord.slice(0, -1) + "ies"; // Change "y" to "ies"
  } else if (
    lastWord.endsWith("s") ||
    lastWord.endsWith("x") ||
    lastWord.endsWith("z") ||
    lastWord.endsWith("ch") ||
    lastWord.endsWith("sh")
  ) {
    pluralWord = lastWord + "es"; // Add "es" for words ending in "s", "x", "z", "ch", or "sh"
  } else {
    pluralWord = lastWord + "s"; // Default rule: Add "s"
  }

  // Replace the last word with its plural form
  words[words.length - 1] = pluralWord;

  // Join the words back into a sentence and return it
  return words.join(" ");
}

export function singularizeLastWord(inputString) {
  // Split the string into words
  const words = inputString.split(" ");

  // Get the last word
  const lastWord = words[words.length - 1];

  // Define the singularization rules
  let singularWord;

  // If the word ends with 'ies', change it to 'y'
  if (lastWord.endsWith("ies")) {
    singularWord = lastWord.slice(0, -3) + "y"; // Change "ies" to "y"
  }
  // If the word ends with 'es', remove the 'es'
  else if (
    lastWord.endsWith("es") &&
    !(
      lastWord.endsWith("xes") ||
      lastWord.endsWith("ches") ||
      lastWord.endsWith("shes")
    )
  ) {
    singularWord = lastWord.slice(0, -2); // Remove "es"
  }
  // If the word ends with 's', remove the 's' (general case like "accounts" -> "account")
  else if (lastWord.endsWith("s")) {
    singularWord = lastWord.slice(0, -1); // Remove "s"
  } else {
    singularWord = lastWord; // If no plural form found, keep the word as it is
  }

  // Replace the last word with its singular form
  words[words.length - 1] = singularWord;

  // Join the words back into a sentence and return it
  return words.join(" ");
}

export const MAX_FILE_SIZE = 5 * 1024 * 1024;
export const formatFileSize = (sizeInBytes) => {
  if (sizeInBytes < 1024) {
    return `${sizeInBytes} bytes`; // Less than 1 KB
  } else if (sizeInBytes < 1024 * 1024) {
    return `${(sizeInBytes / 1024).toFixed(2)} KB`; // Less than 1 MB
  } else {
    return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`; // 1 MB or more
  }
};


export const getWordCountData = (text = "", maxWords = 150) => {
  const words = text.trim().split(/\s+/).filter(Boolean);
  const wordCount = words.length;
  const wordsLeft = maxWords - wordCount;

  return {
    wordCount,
    wordsLeft,
    isLimitExceeded: wordCount >= maxWords,
    trimmedText: words.slice(0, maxWords).join(" "),
  };
};